import * as yup from "yup";
const loginSchema = yup.object().shape({
  userName: yup.string().required(),
  password: yup.string().required(),
});

export { loginSchema };
